module.exports = __webpack_public_path__ + "img/tutorial-2.95896713.png";